/* eslint-disable global-require */
import { Component, Vue } from "vue-property-decorator";
import NativeApi from "@/api/native";
import SHareApi from "@/api/share";
import { contractPage } from "@/components/contract";
import { vueEnv } from "@/constant";
import store from "@/store";
import { landData } from "@/shared/utils/landData";

const ruleUrl = require("@/assets/contracts/activity/invitation.txt.html");
const style = require("./index.module.scss");

const urlMap: Dictionary<string> = {
  dev: `${landData.getUrlOrign()}/AppFinaceShareH5/dev/latest/index.html#/invitation`,
  mock: `${landData.getUrlOrign()}/AppFinaceShareH5/fat/latest/index.html#/invitation`,
  fat: `${landData.getUrlOrign()}/AppFinaceShareH5/fat/latest/index.html#/invitation`,
  uat: `${landData.getUrlOrign()}/AppFinaceShareH5/uat/latest/index.html#/invitation`,
  pro: `${landData.getUrlOrign()}/AppFinaceShareH5/latest/index.html#/invitation`,
};

const url = urlMap[vueEnv] || "";

@Component({ name: "CampaignShare" })
export default class CampaignShare extends Vue {
  private participants: string[] = [];

  private succInviteeNum = 0;

  private rewards = "0";

  private animate = false;

  private clickWeChatShare() {
    this.$ubtPageButton("邀请好友活动页_分享至微信");

    const shareConfig = {
      title: "新用户专享高额免息券，贷款首选臻有钱",
      desc: "专业机构精选合规，安全产品，解决您的燃眉之急",
      tapType: 1,
      shareUrl: `${url}?inviterId=${store.state.base.userId}`,
      imageUrl: `${landData.getUrlOrign()}/resource/Finance/FinanceH5/vhxooUM6AXg_oMPVlXbD9.png`,
      shareImageUrl: `${landData.getUrlOrign()}/resource/Finance/FinanceH5/vhxooUM6AXg_oMPVlXbD9.png`,
    };
    NativeApi.directItemShare(shareConfig);
  }

  private clickFriendShare() {
    this.$ubtPageButton("邀请好友活动页_分享至朋友圈");
    const shareConfig = {
      title: "新用户专享高额免息券，贷款首选臻有钱",
      desc: "专业机构精选合规，安全产品，解决您的燃眉之急",
      tapType: 2,
      shareUrl: `${url}?inviterId=${store.state.base.userId}`,
      imageUrl: `${landData.getUrlOrign()}/resource/Finance/FinanceH5/vhxooUM6AXg_oMPVlXbD9.png`,
      shareImageUrl: `${landData.getUrlOrign()}/resource/Finance/FinanceH5/vhxooUM6AXg_oMPVlXbD9.png`,
    };
    NativeApi.directItemShare(shareConfig);
  }

  private clickQQShare() {
    this.$ubtPageButton("邀请好友活动页_分享至QQ");
    const shareConfig = {
      title: "新用户专享高额免息券，贷款首选臻有钱",
      desc: "专业机构精选合规，安全产品，解决您的燃眉之急",
      tapType: 3,
      shareUrl: `${url}?inviterId=${store.state.base.userId}`,
      imageUrl: `${landData.getUrlOrign()}/resource/Finance/FinanceH5/vhxooUM6AXg_oMPVlXbD9.png`,
      shareImageUrl: `${landData.getUrlOrign()}/resource/Finance/FinanceH5/vhxooUM6AXg_oMPVlXbD9.png`,
    };
    NativeApi.directItemShare(shareConfig);
  }

  // 查看活动规则
  private viewRule() {
    contractPage.open(ruleUrl);
    this.$ubtPageButton("邀请好友活动页_活动规则");
  }

  private async mounted() {
    const res = await SHareApi.getParticipants("20191100001");
    this.participants = res.participants;
    this.succInviteeNum = res.succInviteeNum;
    this.rewards = res.rewards;
    setInterval(this.scrollText, 2000);
  }

  private scrollText() {
    this.animate = true;
    setTimeout(() => {
      this.participants.push(this.participants[0]);
      this.participants.shift();
      this.animate = false;
    }, 500);
  }

  private render() {
    return (
      <div>
        <img class={style.head_title} src={require("./images/title.png")} />
        <div class={style.head_contain}>
          <img class={style.head_bg} src={require("./images/head_bg.png")} />
          <div class={style.head_carousel}>
            <ul class={this.animate && style.head_carousel_top}>
              {this.participants.map((item) => (
                <li>{item}</li>
              ))}
            </ul>
          </div>
          <div class={style.head_rule} onclick={this.viewRule}>
            活动规则
            <img
              class={style.head_rule_row}
              src={require("./images/row.png")}
            />
          </div>
          <p class={style.head_text}>送好友18元新人免息券</p>
        </div>
        <div class={style.invite_contain}>
          <div class={style.invite_channel}>
            <img
              class={style.invite_title_bg}
              src={require("./images/invite_title_bg.png")}
            />
            <div class={style.invite_share}>
              <div class={style.red_packet_contain}>
                <div class={style.red_line}></div>
                <div class={style.red_packet_flex_box}>
                  <div class={style.red_packet_flex_box_item}>
                    <div class={style.tip}>
                      <img
                        class={style.money_bg}
                        src={require("./images/money_bg.png")}
                      />
                      <div class={style.money_label}>得20元</div>
                    </div>
                    <div class={style.red_packet_bg}>
                      <img
                        class={style.red_packet}
                        src={require("./images/red_packet.png")}
                      />
                    </div>
                    <div class={style.red_packet_text}>邀请1人</div>
                  </div>
                  <div class={style.red_packet_flex_box_item}>
                    <div class={style.tip}>
                      <img
                        class={style.money_bg}
                        src={require("./images/money_bg.png")}
                      />
                      <div class={style.money_label}>得40元</div>
                    </div>
                    <div class={style.red_packet_bg}>
                      <img
                        class={style.red_packet}
                        src={require("./images/red_packet.png")}
                      />
                    </div>
                    <div class={style.red_packet_text}>邀请2人</div>
                  </div>
                  <div class={style.red_packet_flex_box_item}>
                    <div class={style.tip}>
                      <img
                        class={style.money_bg}
                        src={require("./images/money_bg.png")}
                      />
                      <div class={style.money_label}>得60元</div>
                    </div>
                    <div class={style.red_packet_bg}>
                      <img
                        class={style.red_packet}
                        src={require("./images/red_packet.png")}
                      />
                    </div>
                    <div class={style.red_packet_text}>邀请3人</div>
                  </div>
                  <div class={style.red_packet_flex_box_item}>
                    <div class={style.tip}>
                      <img
                        class={style.money_bg}
                        src={require("./images/money_bg.png")}
                      />
                      <div class={style.money_label}>得80元</div>
                    </div>
                    <div class={style.red_packet_bg}>
                      <img
                        class={style.red_packet}
                        src={require("./images/red_packet.png")}
                      />
                    </div>
                    <div class={style.red_packet_text}>邀请4人</div>
                  </div>
                </div>
              </div>
              <span class={style.line}></span>
              <span class={style.invite_friend}>马上分享 邀请好友</span>
              <span class={style.line}></span>
            </div>
            <div class={style.invite_share_box}>
              <div
                class={style.invite_share_box_item}
                onclick={this.clickWeChatShare}
              >
                <img
                  class={style.invite_share_img}
                  src={require("./images/icon_wechat@2x.png")}
                />
                <div class={style.invite_share_text}>微信好友</div>
              </div>
              <div
                class={style.invite_share_box_item}
                onclick={this.clickFriendShare}
              >
                <img
                  class={style.invite_share_img}
                  src={require("./images/icon_friends@2x.png")}
                />
                <div class={style.invite_share_text}>朋友圈</div>
              </div>
              <div
                class={style.invite_share_box_item}
                onclick={this.clickQQShare}
              >
                <img
                  class={style.invite_share_img}
                  src={require("./images/icon_QQ@2x.png")}
                />
                <div class={style.invite_share_text}>QQ</div>
              </div>
            </div>
          </div>
          <div class={style.invite_guid}>
            <div class={style.invite_guid_title}>邀请攻略</div>
            <div class={style.invite_guid_steps}>
              <div
                class={[style.invite_guid_step, style.invite_guid_step_left]}
              >
                1
              </div>
              <div class={style.invite_guid_step}>2</div>
              <div
                class={[style.invite_guid_step, style.invite_guid_step_right]}
              >
                3
              </div>
            </div>
            <div class={style.invite_guid_text}>
              <div>发送邀请给好友</div>
              <div>好友提现并还款</div>
              <div>获得邀请奖励</div>
            </div>
          </div>
          <div class={style.invite_score}>
            <div class={style.invite_score_title}>邀请成绩</div>
            <div class={style.invite_score_box}>
              <div class={style.invite_score_box_item}>
                <div class={style.invite_score_box_item_title}>成功邀请</div>
                <div>
                  <span class={style.invite_score_box_item_number}>
                    {this.succInviteeNum}
                  </span>
                  <span class={style.invite_score_box_item_unit}>人</span>
                </div>
              </div>
              <div class={style.invite_score_center_line}></div>
              <div class={style.invite_score_box_item}>
                <div class={style.invite_score_box_item_title}>累计奖励</div>
                <div>
                  <span class={style.invite_score_box_item_number}>
                    {this.rewards}
                  </span>
                  <span class={style.invite_score_box_item_unit}>元</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
